import { render } from "./ProductDataPage.vue?vue&type=template&id=d5cc7cb6&scoped=true"
import script from "./ProductDataPage.vue?vue&type=script&lang=js"
export * from "./ProductDataPage.vue?vue&type=script&lang=js"

import "./ProductDataPage.vue?vue&type=style&index=0&id=d5cc7cb6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5cc7cb6"]])

export default __exports__